import { api } from '../api';
import { session } from '../auth';
import { encryptFields, hasPublicKey, setPublicKey } from '../encryption';
import type { Role } from '../auth';

interface LoginResp {
  id: string;
  email: string;
  token: string;
  roles: Role[];
  firstname?: string;
  lastname?: string;
  mustChangePassword?: boolean;
}

export async function bootstrapPublicKey(): Promise<void> {
  if (hasPublicKey()) return;
  const key = await api.get<string>('/auth');
  if (key) setPublicKey(key);
}

export async function login(email: string, password: string): Promise<LoginResp> {
  await bootstrapPublicKey();
  const payload = encryptFields({ email, password });
  const resp = await api.post<LoginResp>('/auth/login', payload);
  if (!resp.roles?.some(r => r === 'ADMIN' || r === 'CREATOR')) {
    throw Object.assign(new Error('Account does not have admin or creator access'), { code: 'FORBIDDEN' });
  }
  session.save(resp, email);
  return resp;
}

export async function logout(): Promise<void> {
  try { await api.post('/api/user/logout', {}); } catch {}
  session.clear();
}

export async function rotatePassword(currentPassword: string, newPassword: string): Promise<void> {
  await bootstrapPublicKey();
  const payload = encryptFields({ currentPassword, newPassword });
  await api.post('/auth/password/change', payload);
}
